import React, { useState, useEffect } from 'react';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';

import ErrorModal from '@/component/common/modal/ErrorModal';
import './AddTicket.css';

// Import form create ticket
import EscalateTicket from '@/component/ticketList/EscalateTicket';
import QaTicket from '@/component/ticketList/QaTicket';
import HelpdeskCreateTicket from '@/component/ticketList/HelpdeskCreateTicket';
import KnowledgeTicket from '@/component/ticketList/KnowledgeTicket';

// Recoil
import { useRecoilValue } from 'recoil';
import {
    permissionCreateQATicket
} from './handler/AddTicketHandler';

import { getCreateTicketTypeDefault } from '@/component/ticketList/handler/TicketListHandler';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { cloneDeep } from 'lodash';
import MasterKnowledgeTicket from '@/component/ticketList/MasterKnowledgeTicket';
import Utils from '@/common/utils/utils';
import { corporationAtom } from '@/state/atom/corporationAtom';

export default function AddTicket(props) {
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);
    const [createTicketType, setCreateTicketType] = useState();
    const parentCreateTicketType = cloneDeep(props.createTicketType) || '';
    const corporationDetail = useRecoilValue(corporationAtom);

    useEffect(() => {
        const createTicketTypeDefault = getCreateTicketTypeDefault(
            props.ticketListType,
            parentCreateTicketType
        );
        setCreateTicketType(createTicketTypeDefault);
    }, [userDetail, props.ticketListType]);

    const permissionCreateTicketKnowledgeAddComponent = (isCustomer) => {
        if (corporationDetail && [Constant.CORPORATION_CONTRACT_TYPE.GUEST].includes(corporationDetail.contractType)) {
            return false;
        }
        if (corporationDetail && [Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)) {
            let inviterSetting = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting);
            return inviterSetting?.usingKnowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON;
        }
    
        return !isCustomer //&& projectInuseDetail.isDesk;
    };

    return (
        <div className="mainWrap">
            {/* <LoadingPanel isLoading={isLoading} /> */}
            {/* escalate */}
            {((props.isTargetProjectOfTicket &&
                props.isAtTicketDetail &&
                Utils.isGeneralUserWithoutGuest(userDetail)) || (createTicketType === Constant.TICKET_TYPE.ESCALATION)) && (
                    <EscalateTicket
                        {...props}
                        isAtTicketDetail={true}
                        fileUploading={props.fileUploading}
                        setFileUploading={props.setFileUploading}
                        isTargetProjectOfTicket={props.isTargetProjectOfTicket}
                        setIsTargetProjectOfTicket={props.setIsTargetProjectOfTicket}
                        customerThread={props.customerThread}
                        internalThread={props.internalThread}
                        customerReferenceThread={props.customerReferenceThread}
                        escalationThread={props.escalationThread}
                        delegateThread={props.delegateThread}
                        setSelectThread={props.setSelectThread}
                        userDetail={userDetail}
                        ticketOriginInfor={props.ticketOriginInfor}
                        isCreateTicket={props.isShowButtonEscalationTicket}
                        ticketIdSelected={props.ticketId}
                        setCreateTicketType={setCreateTicketType}
                        setIsModalUploadFileError={setIsModalUploadFileError}
                    />
                )}

            {/* Ticket QA (QA in list panel) */}
            {permissionCreateQATicket(props.ticketListType, userDetail, projectInuseDetail) &&
            createTicketType === Constant.TICKET_TYPE.QA ? (
                <QaTicket {...props} setIsModalUploadFileError={setIsModalUploadFileError} />
            ) : (
                ''
            )}

            {props.ticketListType === Constant.MENU_SELECT_TYPE.TICKET_LIST_HELP_DESK_SIDE &&
                !props.isAtTicketDetail &&
                ![
                    Constant.TICKET_TYPE.QA,
                    Constant.TICKET_TYPE.KNOWLEDGE,
                    Constant.TICKET_TYPE.MASTER_KNOWLEDGE,
                    Constant.TICKET_TYPE.ESCALATION
                ].includes(createTicketType) && <HelpdeskCreateTicket {...props} />}

            {/* Invitation ticket knowledge */}
            {permissionCreateTicketKnowledgeAddComponent(props.isCustomer) &&
            createTicketType === Constant.TICKET_TYPE.KNOWLEDGE ? (
                <KnowledgeTicket
                    {...props}
                    userDetail={userDetail}
                    setIsModalUploadFileError={setIsModalUploadFileError}
                />
            ) : (
                ''
            )}

            {permissionCreateTicketKnowledgeAddComponent(props.isCustomer) &&
            createTicketType === Constant.TICKET_TYPE.MASTER_KNOWLEDGE ? (
                <MasterKnowledgeTicket
                    {...props}
                    userDetail={userDetail}
                    setIsModalUploadFileError={setIsModalUploadFileError}
                />
            ) : (
                ''
            )}

            <ErrorModal
                open={isModalUploadFileError}
                message={`${props.fileUploading?.file?.name} ${I18n.get('USER04MSG004')}`}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
                title={'Upload fail'}
            ></ErrorModal>
        </div>
    );
}
